import React, { FC } from "react";

export const KnowledgeQuestion: FC = () => {
  return <div>TODO knowledge</div>;
};
